import React from "react";
import { Dialog } from "@material-ui/core";
import { Label } from "./labels";

interface ITagModalProps {
  isOpen: boolean;
  onClose(): void;
  articleId: number;
}

const TagModal: React.FC<ITagModalProps> = ({ isOpen, onClose, articleId }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
      <Label
        onClose={onClose}
        articleId={articleId}
        setLabel={null}
        snippetLabels={null}
        removeLabel={null}
      />
    </Dialog>
  );
};

export default TagModal;
